import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";
import {
    FiLinkedin,
    FiInstagram,
    FiFacebook,
    FiYoutube,
    FiSend,
    FiMessageCircle,
    FiShoppingBag,
} from "react-icons/fi";

const ICONS = {
    linkedin: { Icon: FiLinkedin, label: "LinkedIn" },
    instagram: { Icon: FiInstagram, label: "Instagram" },
    facebook: { Icon: FiFacebook, label: "Facebook" },
    youtube: { Icon: FiYoutube, label: "YouTube" },
    telegram: { Icon: FiSend, label: "Telegram" },
    whatsapp: { Icon: FiMessageCircle, label: "WhatsApp" },
    ozon: { Icon: FiShoppingBag, label: "Ozon storefront" },
};

export default function SocialIcons({ tone = "light", className = "" }) {
    const { data } = useContext(ContentContext);
    const social = data.social || {};
    const colors =
        tone === "light"
            ? "bg-white/10 hover:bg-white/20 text-white border border-white/15"
            : "bg-navy-50 hover:bg-navy-100 text-navy-800 border border-navy-100";

    return (
        <div className={`flex flex-wrap items-center gap-2 ${className}`}>
            {Object.entries(ICONS).map(([key, def]) => {
                const url = social[key];
                if (!url) return null;
                const { Icon, label } = def;
                return (
                    <a
                        key={key}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={label}
                        className={`w-10 h-10 rounded-full flex items-center justify-center transition ${colors}`}
                    >
                        <Icon className="w-4 h-4" />
                    </a>
                );
            })}
        </div>
    );
}
